// NOTE: hooks
import { useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../hooks/useAuthContext'
import { toast } from 'sonner'
import { useAuth } from '../../hooks/useAuth'
import { useFormik } from 'formik'
import { RegisterValidation } from './authValidation'
import dayjs from 'dayjs'

const useDataRegister = () => {
	const navigate = useNavigate()
	const [urlParams] = useSearchParams()
	const [loading, setLoading] = useState(false)
	const { register } = useAuth()
	const { dispatch } = useAuthContext()

	const handleRegister = async (values: any) => {
		try {
			setLoading(true)

			const data = {
				email: values.email,
				password: values.password,
				fname: values.fname,
				lname: values.lname,
				route: 'staff',
				dob: dayjs(values.dob).toDate(),
				biologicalSex: values.biologicalSex,
				persona: values.persona
			}

			const response = await register(data)
			const json = await response.json()

			if (!response.ok) throw new Error(json.error)

			// NOTE: save the user to local storage and update the auth context
			localStorage.setItem('user', JSON.stringify(json))
			dispatch({ type: 'LOGIN', payload: json })

			// NOTE: create a new instance of search and remove redirect as it's already being redirected and pass search to navigate
			const newParams = new URLSearchParams(urlParams)
			newParams.delete('redirect')
			navigate({
				pathname: '/onboarding',
				search: newParams.toString()
			})
		} catch (error: any) {
			toast.error("Couldn't complete your signup", { description: error.message })
		} finally {
			setLoading(false)
		}
	}

	// NOTE: hook to use formik in a custom form
	const { values, errors, touched, handleChange, handleSubmit, handleBlur, setFieldValue } =
		useFormik({
			initialValues: {
				email: '',
				fname: '',
				lname: '',
				dob: '',
				biologicalSex: '',
				persona: '',
				password: '',
				confirmPwd: ''
			},
			validationSchema: RegisterValidation,
			onSubmit: (values, { setSubmitting }) => {
				handleRegister(values)
				setSubmitting(false)
			}
		})

	return {
		loading,
		values,
		errors,
		touched,
		handleChange,
		handleSubmit,
		handleBlur,
		setFieldValue
	}
}
export default useDataRegister
